/** @jsx isolateComponent */
import { labelStyles, withModifier } from '@zapier/common-utils';
import { isolateComponent } from '@zapier/style-encapsulation';
import { Colors, Icon } from '@zapier/design-system';
const HelpCenterLinkIconStyles = labelStyles(__filename, {
    root: (props) => [
        {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: Colors.neutral100,
            border: `1px solid ${Colors.neutral300}`,
        },
        withModifier(`${props.size}`, {
            borderRadius: Math.ceil(0.25 * props.size),
            height: props.size,
            width: props.size,
        }),
    ],
});
/**
 * This was partially copied from design-system-microlibrary
 * Renders an icon with some styling around it. Rebrand only.
 */
const HelpCenterLinkIcon = (props) => {
    const { size } = props;
    const iconSize = Math.ceil(0.6 * size);
    let color = 'neutral600';
    if (props.name === 'arrowOffsite' || props.isActive)
        color = 'blueJeans';
    if (props.color)
        color = props.color;
    return (isolateComponent("span", { css: HelpCenterLinkIconStyles.root(props) },
        isolateComponent(Icon, { color: color, name: props.name, size: iconSize })));
};
export default HelpCenterLinkIcon;
